import { Typography } from "@mui/material";
import {
  CartesianGrid,
  LabelList,
  Legend,
  Line,
  LineChart,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from "recharts";
import DuomenysKraunami from "../shared/DuomenysKraunami";
import { isAllDataNull } from "../../functions/produktyvumas/grafikuReziai";
import { MultiColorMix } from "../../constants/Spalvos";
import DuomenuNera from "../shared/DuomenuNera";
import { useEffect, useState } from "react";

/**
 * Diagramos su daug stulpeliu komponentas
 * @param {string} pavadinimas diagramos pavadinimas
 * @param {boolean} isLoading ar kraunami duomenys, jei taip returns {DuomenysKraunami} komponentas
 * @param {Array []} chartData
 * @param {Number} yAxisMin
 * @param {Number} yAxisMin
 * @param {Array []} raktai
 * @returns
 */
const DaugLinijuGrafikas = ({
  pavadinimas,
  isLoading,
  chartData,
  yAxisMin,
  yAxisMax,
  raktai,
  xAsis,
  neraDuomenenuTekstas,
  minHeight = "280px",
}) => {
  const [reikiaEtiketes, setReikiaEtiketes] = useState(true);

  useEffect(() => {
    const updateLegendPosition = () => {
      if (window.innerWidth < 1400 || window.innerWidth < 1650) {
        setReikiaEtiketes(false);
      } else {
        setReikiaEtiketes(true);
      }
    };

    updateLegendPosition(); // pradine busena
    window.addEventListener("resize", updateLegendPosition);

    return () => window.removeEventListener("resize", updateLegendPosition);
  }, []);

  if (isLoading) return <DuomenysKraunami pavadinimas={pavadinimas} />;

  const isDataAvailable = isAllDataNull(chartData, xAsis);

  if (isDataAvailable) {
    return <DuomenuNera pavadinimas={pavadinimas} pranesimas={neraDuomenenuTekstas} />;
  }

  return (
    <>
      <Typography>{pavadinimas}</Typography>
      <ResponsiveContainer width="100%" height="100%" minHeight={minHeight}>
        <LineChart data={chartData}>
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey={xAsis} />
          <YAxis domain={[yAxisMin, yAxisMax]} />
          <Tooltip />
          <Legend />
          {raktai.map((key, index) => (
            <Line
              key={key}
              dataKey={key}
              type="monotone"
              strokeWidth="5px"
              stroke={
                key === "1 lak."
                  ? "#7030a0"
                  : key === "2 lak."
                  ? "#00b050"
                  : key === "3 lak."
                  ? "#ff0000"
                  : key === "4-5 lak."
                  ? "#0074e6"
                  : key === "5+ lak."
                  ? "#808000"
                  : MultiColorMix[index]
              }
              name={key}
            >
              {reikiaEtiketes && (key === "1 lak." || key === "3 lak." || raktai.length <= 2) ? (
                <LabelList
                  dataKey={key}
                  fill={
                    key === "1 lak."
                      ? "#7030a0"
                      : key === "2 lak."
                      ? "#00b050"
                      : key === "3 lak."
                      ? "#ff0000"
                      : key === "4-5 lak."
                      ? "#0074e6"
                      : key === "5+ lak."
                      ? "#808000"
                      : MultiColorMix[index]
                  }
                  position="top"
                />
              ) : null}
            </Line>
          ))}
        </LineChart>
      </ResponsiveContainer>
    </>
  );
};

export default DaugLinijuGrafikas;
